import { useEffect } from "react";
import { Control, FieldValues } from "react-hook-form";

type WorkspaceName = string;

export const ADD_COMPANY_WORKSPACE = "addCompany_workspace";

export const useStoredWorskpaceName = (control: Control<FieldValues, any>): WorkspaceName => {
  /// This comes from the `Add Workspace` that's on the tenant selector
  const storedWorkspaceName = localStorage.getItem(ADD_COMPANY_WORKSPACE);
  useEffect(() => {
    if (storedWorkspaceName) {
      control.register("workspaceName", { value: storedWorkspaceName });
      localStorage.removeItem(ADD_COMPANY_WORKSPACE);
    }
  }, [storedWorkspaceName]);

  return storedWorkspaceName;
};

export const hasStoredWorkspaceName = (): boolean => {
  return localStorage.getItem(ADD_COMPANY_WORKSPACE) !== null;
};
